import React, { ReactNode } from 'react';
import './grayPage.module.scss';

type Props = {
  id?: string;
  children: ReactNode;
};

// 課題詳細ページのようにページ上部がグレーの場合に使用する
export const GrayPage = ({ id, children }: Props) => {
  return (
    <div styleName="page" id={id}>
      <div styleName="page-inner">{children}</div>
    </div>
  );
};
